import React from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import next from "./../../../UI/general/Next-Asset.svg"

import collapse from './../../../UI/general/collapse_white.svg'

import gallery from "./../../../UI/Modal/gallery.svg";

interface Props{
    isGalleryActive: any,
    amenityData: any,
    colorsData: any,
    handleCloseGallery: any,
    galleryName: string,
    breadCrumbs: any,
    handleGetBreadCrumbSelected: any,
    comesFromModalGallery: boolean
}

interface State{
    isCollapsed: boolean,
    currentSelectedFile: string,
    currentIndexSelected: number,
    show: boolean,
    rgbaColor: any,
    currentHoverSelected: number
}
declare const window: any;

class DetailedGallery extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentSelectedFile: "",
            isCollapsed: !this.props.comesFromModalGallery,
            currentIndexSelected: 0,
            show: false,
            rgbaColor: {},
            currentHoverSelected: -1
        }
    }

    componentDidMount(): void {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.props.colorsData.main_buttons)
        this.setState({
          rgbaColor: result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : ""
        })
        this.setState({
            currentSelectedFile: this.props.amenityData.links[0].link
        })
        if(this.state.isCollapsed){
            setTimeout(() => {
                this.setState({
                    isCollapsed: false
                })
            },500)
        }
        this.setState({
            show: true
        })
    }

    componentDidUpdate(prevProps: any) {
        if(prevProps.isGalleryActive !== this.props.isGalleryActive && this.props.isGalleryActive){
            this.setState({
                currentSelectedFile: '',
                isCollapsed: this.props.breadCrumbs.length === 0
            }, () => {
                if(this.state.isCollapsed){
                    setTimeout(() => {
                        this.setState({
                            isCollapsed: false
                        })
                    },500)
                }
                this.setState({
                    currentSelectedFile: this.props.amenityData.links[0].link
                }, () => {
                    this.setState({
                        show: true
                    })
                })
            })
        }
        if(prevProps.isGalleryActive !== this.props.isGalleryActive && !this.props.isGalleryActive){
            this.setState({
                currentSelectedFile: '',
                currentIndexSelected: 0,
                show: false
            })
        }
    }

    handleNextPrev = (payload: any) => {
        if(this.state.currentIndexSelected + payload < 0){
            this.setState({
                currentIndexSelected: this.props.amenityData.links.length - 1
            }, () => {
                this.setState({
                    currentSelectedFile: this.props.amenityData.links[this.state.currentIndexSelected].link
                })
            })
        }
        else if(this.state.currentIndexSelected + payload > this.props.amenityData.links.length - 1){
            this.setState({
                currentIndexSelected: 0
            }, () => {
                this.setState({
                    currentSelectedFile: this.props.amenityData.links[this.state.currentIndexSelected].link
                })
            })
        }
        else{
            this.setState({
                currentIndexSelected: this.state.currentIndexSelected + payload
            }, () => {
                this.setState({
                    currentSelectedFile: this.props.amenityData.links[this.state.currentIndexSelected].link
                })
            })
        }
    }

    render(): React.ReactNode {
        return( 
            <div className={this.state.show ? 'gallery-container fade-in':'gallery-container fade-out'}>
                {
                    this.props.isGalleryActive && this.state.show ?
                    <div className={this.state.isCollapsed ? 'gallery-file-container-wide':'gallery-file-container'}>
                        <div className='iframe-container'>
                            <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + this.state.currentSelectedFile} alt="gallery" className='gallery-file' id='image-show'/>
                        </div>
                        {this.props.amenityData.links.length > 1 ?
                            <div className='next-prev-btns'>
                                <div className='prev-btn' style={{backgroundColor: this.props.colorsData.main_buttons}} onClick={() => {this.handleNextPrev(-1)}}>
                                    <img src={collapse} alt=''/>
                                </div>
                                <div className='nex-btn' style={{backgroundColor: this.props.colorsData.main_buttons}} onClick={() => {this.handleNextPrev(1)}}>
                                    <img src={collapse} alt=''/>
                                </div>
                            </div>:null
                        }
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-gallery-btn-collapsed':'sidebar-gallery-btn'}
                    onClick = {() => {
                        this.setState({
                            isCollapsed: !this.state.isCollapsed
                        })
                    }}
                >
                    <img src={collapsed} alt=""/>
                </div>
                <div className={this.state.isCollapsed ? 'sidebar-gallery-container-collapsed':'sidebar-gallery-container'}>
                    <div 
                        className="general-gallery-close-container"
                        onClick={() => {
                            this.setState({
                                isCollapsed: true
                            })
                            setTimeout(() => {
                                this.setState({
                                    show: false
                                })
                            }, 500)
                            setTimeout(() => {
                                this.props.handleCloseGallery()
                            }, 500)
                        }}
                    >
                        <img src={close} alt=''/>
                    </div>
                {
                    this.props.galleryName !== '' && this.props.breadCrumbs.length === 0 ?
                    <div className='gallery-modal-name'
                        onClick={this.props.breadCrumbs.length > 0 ?
                            () => {
                                this.props.handleGetBreadCrumbSelected(-2)
                                this.setState({
                                    show: false
                                })
                            }:() => {}
                        }
                        style={{
                            cursor: this.props.breadCrumbs.length > 0 ? 'pointer':'inherit'
                        }}
                    >{this.props.breadCrumbs.length > 0 ? 'Galería':this.props.galleryName}</div>:null
                }
                {
                    this.props.galleryName !== '' && this.props.breadCrumbs.length > 0 ?
                    <React.Fragment>
                        <div className='general-gallery-img-icon-container'>
                            <img src={gallery} alt=''/>
                        </div>
                        <div className='galerry-name-desktop'>GALERÍA</div>
                    </React.Fragment>:null
                }
                {
                    this.props.breadCrumbs.length > 0 ?
                    <div className='breadcrumbs-gallery-modal-container-desktop'>
                        <div className='breadcrumb' onClick={() => {
                            this.props.handleGetBreadCrumbSelected(-2)
                        }}>Galería</div>
                        {
                            this.props.breadCrumbs.map((breadCrumb :any, index: number) => 
                                <React.Fragment>
                                    <img src={next} alt=''/>
                                    <div 
                                    className={index === this.props.breadCrumbs.length - 1 ? 'last-breadcrumb':'breadcrumb'}
                                    onClick={index === this.props.breadCrumbs.length -1 ? () => {}:() => {
                                        this.props.handleGetBreadCrumbSelected(index + 1)
                                    }}
                                    style={{
                                        backgroundColor: index === this.props.breadCrumbs.length -1 ? this.props.colorsData.main_buttons:'none',
                                        animation: index === this.props.breadCrumbs.length -1 ? 'moveLeftAlt 0.4s ease-in-out 1':'none'
                                    }}
                                    >
                                        {breadCrumb}
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </div>:null
                }
                    <div className='sidebar-gallery-preview-container' style={{top: this.props.breadCrumbs.length > 0 ? '23%':'10%', height: this.props.breadCrumbs.length > 0 ? '77%':'90%'}}>
                    {
                            this.props.amenityData && this.props.amenityData.links && this.state.show ?
                            this.props.amenityData.links.map((render: any, index: number) =>
                                <div className='individual-tour-container' 
                                onClick = {() => {
                                    this.setState({currentSelectedFile: render.link, currentIndexSelected: index})
                                }}
                                style={{
                                    animation: 'fadein ' + (index + 1) + 's ease-in-out 1'
                                }}
                                >
                                    <div 
                                        className='individual-tour-image-container'
                                        style={{
                                        }}
                                        onMouseEnter={() => {
                                            this.setState({
                                                currentHoverSelected: index
                                            })
                                        }}
                                        onMouseLeave={() => {
                                            this.setState({
                                                currentHoverSelected: -1
                                            })
                                        }}
                                    >
                                        <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + (render.link_thumb !== "" ? render.link_thumb:render.link)} alt=""></img>
                                        <div 
                                        className='hover-gallery' 
                                        style={{
                                            opacity: this.state.currentIndexSelected === index || this.state.currentHoverSelected === index ? 1:0, 
                                            backgroundColor: this.state.currentIndexSelected === index ? `rgba(${this.state.rgbaColor.r},${this.state.rgbaColor.g},${this.state.rgbaColor.b}, 0.8)`:this.state.currentHoverSelected === index ? 'rgba(250,250,250,0.56)':'none'
                                        }}/>
                                        <div className='gallery-name'>{render.name.slice(0,-5).replaceAll('_',' ')}</div>
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default DetailedGallery